import { useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import MDLHeader from "./ui/MDLHeader/MDLHeader";

const HEADER_HEIGHT = "64px";

const MDLLayout = () => {
  const headerHeight = HEADER_HEIGHT;

  const location = useLocation();
  const _navigate = useNavigate();

  const [selectedKeys, setSelectedKeys] = useState([
    location.pathname.replace("/", "") || "home",
  ]);

  return (
    <div id="app-layout">
      <MDLHeader height={headerHeight} />
      <div id="mdl-content" style={{ height: `calc(100% - ${headerHeight}` }}>
        <Outlet />
        {!location.pathname.includes("impressum") ? (
          <div id="mdl-footer">
            <div id="footer-seperator"></div>
            <div id="footer-content">
              <div id="impressum-link">
                <a href="./impressum">Impressum</a>
              </div>
              <div id="mdl-name">©2026 by Mission der Liebe</div>
            </div>
          </div>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
};

export default MDLLayout;
